import _styled from "styled-components";
import React from "react";
import { ReactComponent as Delete } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/backspace.svg";

var Container = _styled.div.withConfig({
  displayName: "KeyboardRow__Container",
  componentId: "sc-168ix8h-0"
})(["display:flex;margin-top:10px;&:first-child{margin-top:0;}"]);

export var ButtonSpace = _styled.button.withConfig({
  displayName: "KeyboardRow__ButtonSpace",
  componentId: "sc-168ix8h-1"
})(["flex:1;margin-left:8px;height:60px;"]);
export var BaseButton = _styled(ButtonSpace).withConfig({
  displayName: "KeyboardRow__BaseButton",
  componentId: "sc-168ix8h-2"
})(["padding:0;border:0 none;background:none transparent;font-size:30px;&:focus{outline:0 none;}"]);
export var Button = _styled(BaseButton).withConfig({
  displayName: "KeyboardRow__Button",
  componentId: "sc-168ix8h-3"
})(["border-radius:4px;background-color:white;color:#222222;"]);
export var ImageButton = _styled(BaseButton).withConfig({
  displayName: "KeyboardRow__ImageButton",
  componentId: "sc-168ix8h-4"
})(["display:flex;align-items:center;justify-content:center;svg{display:block;}"]);
export function KeyboardRow(_ref) {
  var keyRowNamesArray = _ref.keyRowNamesArray,
      value = _ref.value,
      onChange = _ref.onChange,
      clearOnDelete = _ref.clearOnDelete,
      disableMinus = _ref.disableMinus;
  return /*#__PURE__*/React.createElement(Container, null, keyRowNamesArray.map(function (keyName, index) {
    switch (keyName) {
      case "BACK":
        return /*#__PURE__*/React.createElement(ImageButton, {
          key: keyName,
          onClick: function onClick() {
            if (value.length === 0) return;

            if (clearOnDelete) {
              onChange("");
              return;
            }

            var newValue = value.slice(0, -1);
            onChange(newValue === "-" ? "" : newValue);
          }
        }, /*#__PURE__*/React.createElement(Delete, null));

      case null:
        // Use idx prefix for key prop to separate number keys and childrens with index key
        return /*#__PURE__*/React.createElement(ButtonSpace, {
          as: "div",
          key: "idx".concat(index)
        });

      case "-":
        return disableMinus ? /*#__PURE__*/React.createElement(ButtonSpace, {
          as: "div",
          key: "idx".concat(index)
        }) : /*#__PURE__*/React.createElement(Button, {
          key: keyName,
          onClick: function onClick() {
            if (value === "") return;
            onChange(value[0] === "-" ? value.slice(1) : "-".concat(value));
          }
        }, "+/-");

      default:
        return /*#__PURE__*/React.createElement(Button, {
          key: keyName,
          onClick: function onClick() {
            return onChange(value + keyName);
          }
        }, keyName);
    }
  }));
}